// Formatting for dashboard figures, axes and tooltips.

const compact = new Intl.NumberFormat("en-US", { notation: "compact", maximumFractionDigits: 1 });
const whole = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });

export const formatCount = (n) => (n == null || Number.isNaN(Number(n)) ? "—" : Math.abs(n) >= 10000 ? compact.format(n) : whole.format(n));

export function formatMoney(n, currency = "USD", { compactLarge = true } = {}) {
  if (n == null || Number.isNaN(Number(n))) return "—";
  const code = String(currency || "USD").toUpperCase();
  const opts = { style: "currency", currency: code, maximumFractionDigits: 2, minimumFractionDigits: Math.abs(n) >= 1000 ? 0 : 2 };
  if (compactLarge && Math.abs(n) >= 100000) Object.assign(opts, { notation: "compact", maximumFractionDigits: 1, minimumFractionDigits: 0 });
  try {
    return new Intl.NumberFormat("en-US", opts).format(n);
  } catch {
    return `${whole.format(n)} ${code}`;
  }
}

/** Short money for axis ticks: $0, $250, $1.2K */
export function formatMoneyTick(n, currency = "USD") {
  try {
    return new Intl.NumberFormat("en-US", { style: "currency", currency: String(currency).toUpperCase(), notation: "compact", maximumFractionDigits: 1 }).format(n);
  } catch {
    return compact.format(n);
  }
}

export const formatCountTick = (n) => compact.format(n);

const parseDay = (iso) => {
  const [y, m, d] = String(iso).split("-").map(Number);
  return new Date(y, (m || 1) - 1, d || 1);
};

/** Axis label for a bucket start date. */
export function bucketLabel(iso, granularity) {
  const d = parseDay(iso);
  if (granularity === "month") return d.toLocaleDateString("en-US", { month: "short" });
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
}

/** Tooltip/table label for a bucket. */
export function bucketTitle(iso, granularity) {
  const d = parseDay(iso);
  if (granularity === "month") return d.toLocaleDateString("en-US", { month: "long", year: "numeric" });
  if (granularity === "week") return `Week of ${d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}`;
  return d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
}

export const RANGE_OPTIONS = [
  { value: "7d", label: "7 days", previous: "previous 7 days" },
  { value: "30d", label: "30 days", previous: "previous 30 days" },
  { value: "90d", label: "90 days", previous: "previous 90 days" },
  { value: "12m", label: "12 months", previous: "previous 12 months" },
];

export const previousLabel = (range) => RANGE_OPTIONS.find((r) => r.value === range)?.previous || "previous period";

/** Change vs the previous period: { pct, direction } or null when not meaningful. */
export function deltaOf(current, previous) {
  const c = Number(current) || 0, p = Number(previous) || 0;
  if (p === 0 && c === 0) return null;
  if (p === 0) return { pct: null, direction: "up", isNew: true };
  const pct = ((c - p) / p) * 100;
  return { pct, direction: Math.abs(pct) < 0.05 ? "flat" : pct > 0 ? "up" : "down" };
}

export function greeting(date = new Date()) {
  const h = date.getHours();
  if (h < 5) return "Good evening";
  if (h < 12) return "Good morning";
  if (h < 18) return "Good afternoon";
  return "Good evening";
}
